<div class="container">
  <div class="number">
    <img
      class="phone-image"
      src="assets/setting/phone.svg"
      *ngIf="!user.email"
    />
    <img
      class="phone-image"
      src="assets/setting/envelope.svg"
      *ngIf="user.email"
    />

    <span>
      {{ phonenumber }}
    </span>
  </div>
</div>
